"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PatientProfileInfo;
require("antd/lib/divider/style");
var _divider = _interopRequireDefault(require("antd/lib/divider"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PatientInfoItem = require("../PatientInfoItem");
var _PatientInfoCard = require("../PatientInfoCard");
var _components = require("../../../components");
var _utils = require("../../../utils");
require("../PatientInfo.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Text = _typography.default.Text;
var getLabel = _utils.GenderUtils.getLabel;
var getFullStateName = _utils.UsaStatesUtils.getFullStateName;
function PatientProfileInfo(_ref) {
  var _ref$patient = _ref.patient,
    patient = _ref$patient === void 0 ? {} : _ref$patient,
    onUnmatch = _ref.onUnmatch;
  var sex = patient.sex,
    pronoun = patient.pronoun,
    birthDate = patient.birthDate,
    phoneNumber = patient.phoneNumber,
    email = patient.email,
    address = patient.address,
    nickName = patient.nickName,
    image = patient.image,
    isMatched = patient.isMatched,
    firstName = patient.firstName,
    middleName = patient.middleName,
    lastName = patient.lastName,
    insurer = patient.insurer,
    medicalRecordNumber = patient.medicalRecordNumber,
    preferredName = patient.preferredName,
    status = patient.status;
  function composeAddress() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      homeAddress = _ref2.homeAddress,
      city = _ref2.city,
      state = _ref2.state,
      zipCode = _ref2.zipCode;
    var stateName = getFullStateName(state);
    var address = [city, stateName, zipCode].join(', ');
    return [homeAddress, address].join('\n');
  }
  var badges = [isMatched ? {
    text: 'Matched',
    type: 'success'
  } : {
    text: 'Unmatched',
    type: 'yellow'
  }];
  var isPatientDeactivated = status === _utils.AccountStatus.Deactivated;
  if (isPatientDeactivated) {
    badges.unshift({
      text: 'Deactivated',
      type: 'warning'
    });
  }
  var fullName = (0, _utils.composeName)([lastName, "".concat(firstName || '', " ").concat(middleName || '')]);
  var sendSupportEmail = function sendSupportEmail() {
    window.location.href = "mailto:support@joinmonument.com?subject=The address has changed for member ( ".concat(fullName, " )");
  };
  return /*#__PURE__*/_react.default.createElement(_PatientInfoCard.PatientInfoCard, {
    title: fullName,
    badges: badges,
    actionContent: onUnmatch ? /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-[10px]"
    }, /*#__PURE__*/_react.default.createElement(_components.TextButton, {
      size: "small",
      onClick: onUnmatch
    }, "Unmatch")) : null
  }, /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Sex:",
    value: getLabel(sex)
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Pronouns:",
    value: pronoun
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Birthday:",
    value: "".concat((0, _utils.formatDate)(birthDate, {
      utc: true
    }), "  (").concat((0, _utils.getAge)(birthDate), " years old)")
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Nickname:",
    value: nickName
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Preffered Name:",
    value: preferredName
  }), /*#__PURE__*/_react.default.createElement(_divider.default, null), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Phone:",
    value: (0, _utils.formatPhoneNumber)(phoneNumber)
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Email:",
    value: /*#__PURE__*/_react.default.createElement("div", {
      className: "ellipsis-text"
    }, email)
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Address:",
    value: /*#__PURE__*/_react.default.createElement(Text, {
      className: "pre-wrap"
    }, composeAddress(address))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-orange1-35 tw-body-sm-medium pt-[15px]"
  }, "Did this patient\u2019s address change?"), /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    className: "tw-body-regular pt-[10px]",
    onClick: sendSupportEmail
  }, "Notify our operations team"), /*#__PURE__*/_react.default.createElement(_divider.default, null), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Insurance:",
    value: insurer
  }), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "Medical Record Number (MRN):",
    value: medicalRecordNumber
  }), /*#__PURE__*/_react.default.createElement(_divider.default, null), /*#__PURE__*/_react.default.createElement(_PatientInfoItem.PatientInfoItem, {
    label: "ID",
    imageId: image,
    valueColSpan: 24,
    offset: 0
  }));
}
PatientProfileInfo.propTypes = {
  title: _propTypes.default.string,
  patient: _propTypes.default.shape({
    firstName: _propTypes.default.string,
    middleName: _propTypes.default.string,
    lastName: _propTypes.default.string,
    sex: _propTypes.default.number,
    pronoun: _propTypes.default.string,
    birthDate: _propTypes.default.string,
    phoneNumber: _propTypes.default.string,
    email: _propTypes.default.string,
    nickName: _propTypes.default.string,
    address: _propTypes.default.shape({
      homeAddress: _propTypes.default.string,
      city: _propTypes.default.string,
      state: _propTypes.default.string,
      zipCode: _propTypes.default.string
    }),
    image: _propTypes.default.string,
    isMatched: _propTypes.default.bool
  }),
  bordered: _propTypes.default.bool
};